import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ar-bracelet"
    path="business/products/ar-bracelet"
    element={<AsyncPage />}
  />,
];
